import React from "react"
import Cabecalho from "../Cabecalho"
import { CadastroAplicativoContextProvider } from "./context/CadastroAplicativoContextProvider"
import { CoresAplicativoContextProvider } from "./context/CoresAplicativoContextProvider"
import { ParametrosAplicativoContextProvider } from "./context/ParametrosAplicativoContextProvider"
import { ArquivosAplicativoContextProvider } from "./context/ArquivosAplicativoContextProvider"
import { ContratoAplicativoContextProvider } from "./context/ContratoAplicativoContextProvider"
import { EstabelecimentosAplicativoContextProvider } from "./context/EstabelecimentosAplicativoContextProvider"
import { CadastroAplicativoFornecedor } from "./CadastroAplicativoFornecedor"
import { FormularioCadastroAplicativo } from "./components/FormularioCadastroAplicativo"
import { FormularioParametrosAplicativo } from "./components/FormularioParametrosAplicativo"
import { FormularioArquivosAplicativo } from "./components/FormularioArquivosAplicativo"
import { FormularioContratoAplicativo } from "./components/FormularioContratoAplicativo"
import { FormularioEstabelecimentosAplicativo } from "./components/FormularioEstabelecimentosAplicativo"

export function Index() {
    return (
        <CoresAplicativoContextProvider>
            <CadastroAplicativoFornecedor />
        </CoresAplicativoContextProvider>
    )
}

export function IndexCadastro() {
    return (
        <CadastroAplicativoContextProvider>
            <Cabecalho pagina="Cadastro do Aplicativo" />
            <FormularioCadastroAplicativo />
        </CadastroAplicativoContextProvider>
    )
}

export function IndexParametros() {
    return (
        <ParametrosAplicativoContextProvider>
            <Cabecalho pagina="Parâmetros do Aplicativo" />
            <FormularioParametrosAplicativo />
        </ParametrosAplicativoContextProvider>
    )
}

export function IndexArquivos() {
    return (
        <ArquivosAplicativoContextProvider>
            <Cabecalho pagina="Arquivos do Aplicativo" />
            <FormularioArquivosAplicativo />
        </ArquivosAplicativoContextProvider>
    )
}

export function IndexContrato() {
    return (
        <ContratoAplicativoContextProvider>
            <Cabecalho pagina="Dados do Contrato" />
            <FormularioContratoAplicativo />
        </ContratoAplicativoContextProvider>
    )
}

export function IndexEstabelecimentos() {
    return (
        <EstabelecimentosAplicativoContextProvider>
            <Cabecalho pagina="Estabelecimentos do Aplicativo" />
            <FormularioEstabelecimentosAplicativo />
        </EstabelecimentosAplicativoContextProvider>
    )
}
